// extracted by mini-css-extract-plugin
export var buttonIcon = "button-wand-module--button-icon--WnDJu";
export var buttonLink = "button-wand-module--button-link--Txwee";
export var buttonNew = "button-wand-module--button-new--rvY7o";
export var buttonWand = "button-wand-module--button-wand--JGKrC";